import { Injectable, inject } from '@angular/core';
import { EmployeeIdentityService } from '../../application/employee-identity.service';
import { UserMetadata } from './user-metadata';

export interface UserMetadataProvider {
  getCurrentUserMetadata(): UserMetadata | null;
}

@Injectable({
  providedIn: 'root',
})
export class AuthUserMetadataProvider implements UserMetadataProvider {
  private readonly employeeIdentityService = inject(EmployeeIdentityService);

  getCurrentUserMetadata(): UserMetadata | null {
    return {
      submittedByEmployeeId: this.employeeIdentityService.getCurrentEmployeeId(),
    };
  }
}
